import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Project } from 'types/store/projectsList';
import {
  selectIsSearchValueEmpty,
  selectAreFiltersEmpty,
} from 'state/ProjectsList/filters/filtersSlice';
import EmptyProjectsTable from './EmptyProjectsTable/EmptyProjectsTable';
import ProjectsTableRow from './ProjectsTableRow/ProjectsTableRow';
import ProjectsTableLastRow from './ProjectsTableLastRow';

interface ProjectsTableBodyProps {
  tableName: string;
  projects: Project[];
  canFetchMoreProjects?: boolean;
  fetchMoreProjects: () => void;
  onAddProject: () => void;
  isConsolidatedView?: boolean;
  onOpenCancelModal?: (projectId: string) => void;
  onOpenOnHoldModal?: (projectId: string) => void;
  onOpenCloseModal?: (projectId: string) => void;
  onRefresh?: () => void;
}

const ProjectsTableBody: FC<ProjectsTableBodyProps> = ({
  tableName,
  projects,
  canFetchMoreProjects = false,
  fetchMoreProjects,
  onAddProject,
  isConsolidatedView = false,
  onOpenCancelModal,
  onOpenOnHoldModal,
  onOpenCloseModal,
  onRefresh,
}) => {
  const isListEmpty = projects.length === 0;
  const isSearchValueEmpty = useSelector(selectIsSearchValueEmpty);
  const areFiltersEmpty = useSelector(selectAreFiltersEmpty);

  return (
    <tbody>
      {!isListEmpty &&
        projects.map((project: Project, index: number) => (
          <ProjectsTableRow
            key={index}
            project={project}
            isOdd={index % 2 !== 0}
            isTableEmpty={isListEmpty}
            isConsolidatedView={isConsolidatedView}
            onOpenCancelModal={onOpenCancelModal}
            onOpenOnHoldModal={onOpenOnHoldModal}
            onOpenCloseModal={onOpenCloseModal}
            onRefresh={onRefresh}
          />
        ))}
      {isListEmpty && (
        <EmptyProjectsTable
          emptySearch={isSearchValueEmpty}
          emptyFilters={areFiltersEmpty}
          addNewProject={onAddProject}
          isConsolidatedView={isConsolidatedView}
        />
      )}
      {!isListEmpty && canFetchMoreProjects && (
        <ProjectsTableLastRow
          isOdd={projects.length % 2 !== 0}
          tableName={tableName}
          onLastRowInView={fetchMoreProjects}
        />
      )}
    </tbody>
  );
};

export default ProjectsTableBody;
